import { render } from "./APIInfo.vue?vue&type=template&id=68b95e0e&scoped=true"
import script from "./APIInfo.vue?vue&type=script&lang=js"
export * from "./APIInfo.vue?vue&type=script&lang=js"

import "./APIInfo.vue?vue&type=style&index=0&id=68b95e0e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\bgnnuserinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b95e0e"]])

export default __exports__